// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"466":"8e45f271","548":"8e45f271"}[chunkId] + ".chunk.css";
};